import {Injectable} from '@angular/core';
import {DataStorageService} from './data-storage.service';
import {MitarbeiterBase} from '../dtos/mitarbeiterBase';

@Injectable({
  providedIn: 'root'
})
export class DataMappingService {
  constructor(private readonly storage: DataStorageService) {}

  async mapMitarbeiterIdToLaufnummerAsync(id: number): Promise<string> {
    const mitarbeiters = await this.storage.getMitarbeiter();
    return this.mapMitarbeiterIdToLaufnummer(id, mitarbeiters);
  }

  mapMitarbeiterIdToLaufnummer(
    id: number,
    mitarbeiters: MitarbeiterBase[]
  ): string {
    const mitarbeiter = this.getMitarbeiterMapIdToLaufnummer(id, mitarbeiters);
    if (mitarbeiter) {
      return mitarbeiter.laufnummer;
    }
    return null;
  }

  async mapMitarbeiterIdToLaufnummerReturnLnAndFncAsync(
    id: number
  ): Promise<string> {
    const mitarbeiters = await this.storage.getMitarbeiter();
    return this.mapMitarbeiterIdToLaufnummerReturnLnAndFnc(id, mitarbeiters);
  }

  async mapMitarbeiterIdToLaufnummerReturnLnAndFnc(
    id: number,
    mitarbeiters: MitarbeiterBase[]
  ): Promise<string> {
    const mitarbeiter = this.getMitarbeiterMapIdToLaufnummer(id, mitarbeiters);
    const fncs = await this.storage.getFunktionen();
    const fnc = fncs?.find(f => f.value === mitarbeiter.funktion);

    if (mitarbeiter) {
      return `${mitarbeiter.laufnummer} - ${fnc?.caption}`;
    }
    return null;
  }

  mapMitarbeiterIdsToLaufnummern(
    ids: number[],
    mitarbeiters: MitarbeiterBase[]
  ) {
    const result: string[] = [];
    for (const id of ids) {
      result.push(this.mapMitarbeiterIdToLaufnummer(id, mitarbeiters));
    }
    return result;
  }

  async mapMitarbeiterIdsToLaufnummernAsync(ids: number[]): Promise<string[]> {
    const miterabeiters = await this.storage.getMitarbeiter();
    return this.mapMitarbeiterIdsToLaufnummern(ids, miterabeiters);
  }

  private getMitarbeiterMapIdToLaufnummer(
    id: number,
    mitarbeiters: MitarbeiterBase[]
  ): MitarbeiterBase {
    if (typeof id !== 'number') {
      console.warn(
        'Input was not number but',
        typeof id,
        '. Trying to parse as int.'
      );
      id = parseInt(id, 10);
    }
    const mitarbeiter = mitarbeiters.find(ma => ma.id === id);
    if (mitarbeiter) {
      return mitarbeiter;
    }
    // console.error('No mitarbeiter found for', id, mitarbeiters);
    return null;
  }
}
